export default {

    state: {
        themeColors: null,
    },

    getters: {
        getThemeColors: state => {
            return state.themeColors;
        },
    },

    mutations: {
        setThemeColors: (state, payload) => {
            state.themeColors = payload;
        },
    },

    actions: {

    }
};
